// extracted by mini-css-extract-plugin
export var configurationSection = "_ss-0";